var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{class:_vm.specialClass,style:([_vm.specialStyle]),on:{"click":function($event){return _vm.action()},"dblclick":_vm.edit}},[_c('div',{staticClass:"pd-0 mg-0",domProps:{"innerHTML":_vm._s(_vm.label)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }